import axiosInstance from "../config/axios.config";

/**
 * The whole board in one call: the banner figures, every Needs Attention queue
 * with its count and value, top sellers and recent bills. Replaces the three
 * separate calls the dashboard used to make.
 */
export const getPharmacyDashboardApi = () => {
  return axiosInstance.get(`pharmacy/dashboard/`);
};

export const getPharmacyDashboardKpisApi = () => {
  return axiosInstance.get(`pharmacy/dashboard/kpis/`);
};

export const getPharmacyStockOutListApi = (params) => {
  return axiosInstance.get(`pharmacy/medicines/stock-out/?${params}`);
};

export const getPharmacyNearExpiryListApi = (params) => {
  return axiosInstance.get(`pharmacy/medicines/near-expiry/?${params}`);
};


export const getPharmacyNonMovingStockListApi = (params) => {
  return axiosInstance.get(`pharmacy/medicines/non-moving-stock/?${params}`);
};

export const getPharmacyPurchaseVsSalesApi = () => {
  return axiosInstance.get(`pharmacy/dashboard/purchase-vs-sales/`);
};

export const getPharmacyTopSellingApi = () => {
  return axiosInstance.get(`pharmacy/dashboard/top-selling/`);
};
